import PropTypes from 'prop-types';
import { Box, Paragraph } from '@qga/roo-ui/components';
import {
  CUSTOMER_SUPPORT_HOTLINE_AU,
  CUSTOMER_SUPPORT_HOTLINE_INTL,
  CUSTOMER_SUPPORT_CALL_HOURS,
  CUSTOMER_SUPPORT_LIVE_CHAT_HOURS,
  CUSTOMER_SUPPORT_CALL_DAYS,
  CUSTOMER_SUPPORT_LIVE_CHAT_DAYS,
  CONTACT_US_URL,
  FAQ_URL,
} from 'config/constants';
import { H3 } from './primitives';
import { H2 } from '../primitives';
import { Column, RedLink, Row } from '../../primitives';

const HelpInfo = ({ bookingRef }) => (
  <Box as="article">
    <H2>Need help with your booking?</H2>
    <Paragraph color="emperor" my={1}>
      Get in touch and quote your booking reference: <strong>{bookingRef}</strong>
    </Paragraph>
    <Row>
      <Column width={['33.33%', 'auto']}>
        <H3>Live Chat</H3>
        <Paragraph lineHeight="20px" mb={0}>
          We are now available via LiveChat between {CUSTOMER_SUPPORT_LIVE_CHAT_HOURS} ({CUSTOMER_SUPPORT_LIVE_CHAT_DAYS}).
        </Paragraph>
        <Paragraph lineHeight="20px" mb={0}>
          <RedLink my={0} label="Chat online" url={CONTACT_US_URL} />
        </Paragraph>
      </Column>
      <Column width={['33.33%', 'auto']}>
        <H3>Call customer support</H3>
        <Paragraph lineHeight="20px" mb={0}>
          Between {CUSTOMER_SUPPORT_CALL_HOURS} ({CUSTOMER_SUPPORT_CALL_DAYS}): <br />
          {CUSTOMER_SUPPORT_HOTLINE_AU}
        </Paragraph>
        <Paragraph lineHeight="20px" mb={0}>
          Outside Australia: <br />
          {CUSTOMER_SUPPORT_HOTLINE_INTL}
        </Paragraph>
      </Column>
      <Column width={['33.33%', 'auto']}>
        <H3>Frequently asked questions</H3>
        <Paragraph lineHeight="20px" mb={0}>
          We have answered some of the most common enquiries. <RedLink my={0} label="Read more" url={FAQ_URL} />
        </Paragraph>
      </Column>
    </Row>
  </Box>
);

HelpInfo.propTypes = {
  bookingRef: PropTypes.string.isRequired,
};

export default HelpInfo;
